import { Skeleton } from '@mui/material';
import React, { Suspense, ComponentType, LazyExoticComponent } from 'react';

type LazyComponentType = 'page' | 'component';

const getFallbackSkeleton = (type: LazyComponentType): React.ReactNode => {
  switch (type) {
    case 'page':
      return (
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100vh"
          className="skeletonStyle"
        />
      );
    case 'component':
    default:
      return (
        <Skeleton
          variant="rectangular"
          width="100%"
          height={300}
          className="skeletonStyle"
        />
      );
  }
};

export default function LazyComponent<T extends ComponentType<any>>(
  importFunc: () => Promise<{ default: T }>,
  type: LazyComponentType = 'component'
): LazyExoticComponent<T> {
  const LazyComponent = React.lazy(importFunc);
  const fallback = getFallbackSkeleton(type);

  return ((props) => (
    <Suspense fallback={fallback}>
      <LazyComponent {...props} />
    </Suspense>
  )) as LazyExoticComponent<T>;
}
